function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.9 5C16.4 2.2 14 0 11 0 7.7 0 5 2.7 5 6c-2.8 0-5 2.2-5 5s2.2 5 5 5h11.5c3 0 5.5-2.5 5.5-5.5 0-2.9-2.2-5.3-5.1-5.5zm-2 4.3l-3.5 3.5c-.2.2-.5.2-.7 0L7.2 9.3c-.2-.2-.2-.5 0-.7l.2-.2c.1-.1.2-.1.4-.1H9V4.5c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v3.8h1.3c.1 0 .3.1.4.1l.2.2c.2.2.2.5 0 .7z",
  fill: "#142246"
});

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-icon.03cf7b90.svg";
export { ForwardRef as ReactComponent };